import React, { createContext, useContext } from "react";
import type { FC, PropsWithChildren } from "react";
import { useTracking } from "@edreamsodigeo/frontend-core";

import { tracking, getTrackingFunctions } from "./config/tracking";
import type {
  TrackingContextProps,
  trackOnContinueButtonClickProps,
  PriceSelectionBoxTrackingContextType,
} from "./contract";

export const TrackingContext = createContext<TrackingContextProps>({
  trackOnContinueButtonClick: (
    _params: trackOnContinueButtonClickProps,
  ): void => {
    /* empty */
  },
});

export const useTrackingContext = (): TrackingContextProps =>
  useContext(TrackingContext);

const PriceSelectionBoxTrackingProvider: FC<
  PropsWithChildren<PriceSelectionBoxTrackingContextType>
> = ({ itineraryData, children }) => {
  const { trackEvent } = useTracking();

  const track = (label: string): void => {
    trackEvent({
      category: tracking.CATEGORY,
      action: tracking.ACTION,
      label: label,
    });
  };

  const trackingFunctions = getTrackingFunctions({
    track,
  });

  const trackOnContinueButtonClick = ({
    wasSelectedPrimePrice,
  }: trackOnContinueButtonClickProps): void => {
    trackingFunctions?.trackOnContinueButtonClick({
      itineraryData,
      wasSelectedPrimePrice,
    });
  };

  return (
    <TrackingContext.Provider value={{ trackOnContinueButtonClick }}>
      {children}
    </TrackingContext.Provider>
  );
};

export default PriceSelectionBoxTrackingProvider;
